import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  TempDocumentDetailResponseWithAny,
  useTempDocumentDetailQuery,
} from "features/document/hooks/queries/useTempDocumentDetailQuery";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { FormProvider, useForm } from "react-hook-form";
import { DocumentForm } from "features/document/utils/getTempSaveRequest";
import useResetDocStates from "features/document/hooks/create/useResetDocStates";
import AnalysisCreateSelectPage from "./AnalysisCreateSelectPage";
import AnalysisCreateFormPage from "./AnalysisCreateFormPage";
import {
  analysisFormStepState,
  selectedAnalysisBusinessTagState,
  selectedAnalysisCityState,
  selectedAnalysisProvinceState,
} from "store/document/analysisDocument";
import useResetAnalysisDocStates from "features/document/hooks/create/analysis/useResetAnalysisDocStates";
import { getBuisnessTagFromTempDoc } from "features/document/utils/getTag";

const AnalysisCreatePage = () => {
  const tempDocumentUuid = useParams().uuid;

  const { data: tempDocumentDetail, isLoading } =
    useTempDocumentDetailQuery(tempDocumentUuid);

  /* 폼 */
  const methods = useForm<DocumentForm>({
    mode: "onBlur",
  });

  const { analysisFormStep } = useAnalysisFormStep(tempDocumentDetail);

  useInitAnalysisDocStates();

  if (isLoading) return null;

  return (
    <FormProvider {...methods}>
      {analysisFormStep === 0 ? (
        <AnalysisCreateSelectPage />
      ) : (
        <AnalysisCreateFormPage />
      )}
    </FormProvider>
  );
};

export default AnalysisCreatePage;

/* Hooks */
const useAnalysisFormStep = (
  tempDocumentDetail?: TempDocumentDetailResponseWithAny,
) => {
  /* 문서 등록 페이지 스텝 */
  const [analysisFormStep, setAnalysisFormStep] = useRecoilState(
    analysisFormStepState,
  );
  const setAnalysisProvince = useSetRecoilState(selectedAnalysisProvinceState);
  const setAnalysisCity = useSetRecoilState(selectedAnalysisCityState);
  const setSelectedBusinessTag = useSetRecoilState(
    selectedAnalysisBusinessTagState,
  );

  const { resetAnalysisDocStates } = useResetAnalysisDocStates();

  // 임시 저장 문서가 존재하면 다음 스텝으로 이동
  useEffect(() => {
    if (tempDocumentDetail) {
      setAnalysisProvince(tempDocumentDetail.provinceName as any);
      setAnalysisCity(tempDocumentDetail.cityName);
      setAnalysisFormStep(1);
      const savedBusinessTag = getBuisnessTagFromTempDoc(tempDocumentDetail);

      if (savedBusinessTag) setSelectedBusinessTag(savedBusinessTag);
    } else {
      resetAnalysisDocStates();
    }
  }, [tempDocumentDetail]);

  return {
    analysisFormStep,
  };
};

const useInitAnalysisDocStates = () => {
  /* Recoil 상태 초기화 */
  const analysisFormStep = useRecoilValue(analysisFormStepState);
  const { resetAnalysisDocStates } = useResetAnalysisDocStates();

  useResetDocStates({
    step: analysisFormStep,
    resetDocStates: resetAnalysisDocStates,
  });
};
